import React from "react";
import Loadable from "../../react-loadable";

const WeaColorPicker = Loadable({
  loader: () => import("./ColorPicker"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});

export default WeaColorPicker;



// WEBPACK FOOTER //
// ./ecology9/wea-color-picker/index.js